import {  Component, OnInit, ViewChild } from '@angular/core';
import { SrubUpService } from '../Services/ScrubUp.service';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from '../Services/AppUserProfile';
 import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs';
 import {MatSort,Sort,MatTableModule,MatSortModule} from '@angular/material';
import {LiveAnnouncer} from '@angular/cdk/a11y';
declare var $: any;
import { MatPaginator} from '@angular/material';
// import { tap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
// import { Subject } from 'rxjs';
import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
// import {MatTableDataSource} from '@angular/material';
interface USERROLE {
  RoleName:string;
  RoleCategory: string;
  IOSCount: string;
  AndroidCount:string
}
@Component({
  selector: 'app-user-role',
  templateUrl: './user-role.component.html',
  styleUrls: ['./user-role.component.scss'],
  providers: [SrubUpService],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class UserRoleComponent implements OnInit {
 displayedColumns: string[] = ['RoleName','AndroidCount','IOSCount','Total'];
 innerDisplayedColumns:string[]=['Public','Private','Other'];
  dataSource: eDataSource;
  ELEMENT_DATA: USERROLE[] =[];
  public loading = false;
  data:any=[];
  selectedRowIndex: any;
  loginUserId: number;
  showMyContainerflag: boolean = false;
  @ViewChild(MatSort)sort!: MatSort;
  row:any;
  pageLength = 100;
  pageSize = 2;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
 
  constructor(private _liveAnnouncer: LiveAnnouncer, private scrubUpService: SrubUpService,private cookieService: CookieService, private appUser: AppWideUser, private token: Token) {

 if (this.appUser.UserName == undefined && this.token.access_token == undefined || this.appUser.UserName == null && this.token.access_token == null) {

  if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUser = JSON.parse(this.cookieService.get('AppWideUser'));
        this.token = JSON.parse(this.cookieService.get('Token'));
    }
     this.loginUserId = this.appUser.UserId;
     
    }
  
  ngOnInit() { 
   
  this.getUserRoleDetails();
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
   
  }
  
  highlight(row){
    //console.log(row);
    this.selectedRowIndex = row.RoleName;
  }
  showMyContainer(row,index)
  { 
    //console.log(row);
    this.row=[];
      this.row = row;
      this.showMyContainerflag=true;
  
  }
  getUserRoleDetails() {
    this.loading = true;
    this.data=[];
    this.scrubUpService.getUserRoleDetails(this.token).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true) {
        
       let userData = x['Data'];
        for(var i=0;i<x['Data'].length;i++)
        {
          userData[i].Total=x['Data'][i].IOSCount + x['Data'][i].AndroidCount;
     
        }
        //console.log( userData);
       this.data =  userData;
        this.dataSource = new eDataSource(this.data);
        // this.dataSource.paginator = this.paginator ;
      
      }
      this.loading = false;
     
    },
      error => {
        this.loading = false;
      })
  }

  displayDetail()
  {
    //console.log("test");
  }
  


  announceSortChange(sortState: Sort) {
    
    if (sortState.direction =='asc') {
     // this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
     
      this.data.sort((a, b) => a[sortState.active] > b[sortState.active] ? 1 : a[sortState.active] < b[sortState.active] ? -1 : 0);
      //console.log( this.data);
      return this.dataSource = new eDataSource(this.data);
    } else {
     // this._liveAnnouncer.announce('Sorting cleared');
      this.data.sort((a, b) => a[sortState.active] < b[sortState.active] ? 1 : a[sortState.active] > b[sortState.active] ? -1 : 0);
      //console.log( this.data);
      return this.dataSource = new eDataSource(this.data);
    }
  }


  ngAfterViewInit (){
    //console.log("test");
  }

}
export class eDataSource extends DataSource<any> {

  constructor( private element: Element[]) {
    super();
  }
paginator:any
  connect(): Observable<Element[]> {
    return Observable.of(this.element);
  }

  disconnect() {}
  
}


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/user-role/user-role.component.ts